var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _g, _path32, _g2, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgScanBox(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 68,
    viewBox: "0 0 76 68",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M75.056 41.5813L38.173 20.2873C37.491 19.8933 36.39 19.8963 35.718 20.2873L31.597 22.6823L27.449 20.2873C26.767 19.8933 25.666 19.8963 24.994 20.2873L1.00601 34.2273C0.328012 34.6213 0.332008 35.2553 1.01401 35.6493L37.897 56.9433C38.238 57.1403 38.682 57.2383 39.126 57.2383H49.848C50.293 57.2393 50.738 57.1403 51.078 56.9433L75.066 43.0033C75.737 42.6123 75.739 41.9753 75.056 41.5813Z",
    fill: "#615A59"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.2277 32.8083L11.2217 34.9333C11.2207 35.1923 11.3927 35.4514 11.7357 35.6494L48.6177 56.9434C49.2997 57.3374 50.3947 57.3374 51.0727 56.9434L75.0607 43.0034C75.3957 42.8094 75.5637 42.5534 75.5647 42.2974L75.5707 40.1724L11.2277 32.8083Z",
    fill: "url(#paint0_linear_1921_13966)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M75.0585 39.4563L38.1765 18.1623C37.4945 17.7683 36.3935 17.7713 35.7215 18.1623L11.7336 32.1023C11.0556 32.4963 11.0595 33.1303 11.7415 33.5243L48.6236 54.8183C49.3055 55.2123 50.4006 55.2123 51.0786 54.8183L75.0665 40.8783C75.7395 40.4873 75.7415 39.8503 75.0585 39.4563Z",
    fill: "#FFCB27"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M38.1765 18.1623C37.4945 17.7683 36.3935 17.7713 35.7215 18.1623L11.7336 32.1023C11.0556 32.4963 11.0595 33.1303 11.7415 33.5243L44.9715 53.2673L47.2305 54.0143H49.8905L38.1765 18.1623Z",
    fill: "#BC7400"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M12.6574 18.4001L12.6514 32.5711C12.6504 32.8301 12.8224 33.0891 13.1654 33.2871L48.6184 53.7561C49.3004 54.1501 50.3954 54.1501 51.0734 53.7561L73.7064 40.5981C74.0414 40.4041 74.2094 40.1481 74.2104 39.8911L74.2164 25.7202L12.6574 18.4001Z",
    fill: "url(#paint1_linear_1921_13966)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M71.7448 42.2701L71.2998 42.0131V26.9741L71.7448 27.2311V42.2701Z",
    fill: "#BC7400"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M73.4591 41.2802L71.7451 42.2702V27.2312L73.4591 26.2412V41.2802Z",
    fill: "#E69F00"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M71.7448 27.2311L71.2998 26.9741L73.0138 25.9851L73.4588 26.2411L71.7448 27.2311Z",
    fill: "#E69F00"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M62.4997 47.6083L62.0547 47.3513V32.3123L62.4997 32.5693V47.6083Z",
    fill: "#BC7400"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M64.213 46.6183L62.5 47.6083V32.5693L64.213 31.5803V46.6183Z",
    fill: "#E69F00"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M62.4997 32.5692L62.0547 32.3122L63.7687 31.3232L64.2127 31.5802L62.4997 32.5692Z",
    fill: "#E69F00"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M53.2536 52.9461L52.8086 52.6891V37.6501L53.2536 37.9071V52.9461Z",
    fill: "#BC7400"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M54.9679 51.9562L53.2539 52.9462V37.9072L54.9679 36.9182V51.9562Z",
    fill: "#E69F00"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M53.2536 37.9071L52.8086 37.6501L54.5226 36.6611L54.9676 36.9182L53.2536 37.9071Z",
    fill: "#E69F00"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M27.6191 42.136L28.0631 41.8791V26.8411L27.6191 27.0981V42.136Z",
    fill: "#CF8800"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M25.9053 41.1472L27.6193 42.1361V27.0981L25.9053 26.1082V41.1472Z",
    fill: "#BC7400"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M27.6193 27.0981L28.0633 26.8411L26.3503 25.8511L25.9053 26.1081L27.6193 27.0981Z",
    fill: "#E69F00"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M36.8643 47.474L37.3092 47.218V32.179L36.8643 32.436V47.474Z",
    fill: "#CF8800"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M35.1514 46.485L36.8644 47.4741V32.4361L35.1514 31.446V46.485Z",
    fill: "#BC7400"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M36.8644 32.436L37.3094 32.179L35.5954 31.189L35.1514 31.446L36.8644 32.436Z",
    fill: "#E69F00"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M46.1104 52.8121L46.5553 52.5561V37.5171L46.1104 37.7741V52.8121Z",
    fill: "#CF8800"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M44.3965 51.8232L46.1105 52.8122V37.7742L44.3965 36.7842V51.8232Z",
    fill: "#BC7400"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M46.1105 37.7741L46.5555 37.5171L44.8415 36.5281L44.3965 36.7841L46.1105 37.7741Z",
    fill: "#E69F00"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M18.3652 36.7943L18.8102 36.5373V21.4993L18.3652 21.7552V36.7943Z",
    fill: "#CF8800"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M16.6514 35.8044L18.3654 36.7943V21.7553L16.6514 20.7664V35.8044Z",
    fill: "#BC7400"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M18.3654 21.7552L18.8104 21.4993L17.0964 20.5093L16.6514 20.7663L18.3654 21.7552Z",
    fill: "#E69F00"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M11.2277 15.4492L11.2217 17.5742C11.2207 17.8332 11.3927 18.0922 11.7357 18.2902L48.6177 39.5842C49.2997 39.9782 50.3947 39.9782 51.0727 39.5842L75.0607 25.6442C75.3957 25.4492 75.5637 25.1942 75.5647 24.9372L75.5707 22.8122L11.2277 15.4492Z",
    fill: "url(#paint2_linear_1921_13966)"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M75.0585 22.0962L38.1765 0.802189C37.4945 0.408189 36.3935 0.411189 35.7215 0.802189L11.7336 14.7422C11.0556 15.1362 11.0595 15.7702 11.7415 16.1642L48.6236 37.4582C49.3055 37.8522 50.4006 37.8522 51.0786 37.4582L75.0665 23.5182C75.7395 23.1282 75.7415 22.4902 75.0585 22.0962Z",
    fill: "#FFCB27"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M73.4036 22.0961L38.1846 1.76215C37.5026 1.36815 36.4016 1.37115 35.7296 1.76215L13.3976 14.7462C12.7196 15.1402 12.7236 15.7742 13.4056 16.1682L48.6246 36.5021C49.3066 36.8961 50.4016 36.8961 51.0796 36.5021L73.4116 23.5181C74.0836 23.1281 74.0856 22.4901 73.4036 22.0961Z",
    fill: "url(#paint3_linear_1921_13966)"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M51.0797 36.5032L58.5487 32.1612L38.1847 20.4042C37.5027 20.0102 36.4017 20.0132 35.7297 20.4042L28.2607 24.7462L48.6247 36.5032C49.3067 36.8972 50.4017 36.8972 51.0797 36.5032Z",
    fill: "#FFCB27"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1921_13966",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 12,
    y: 1,
    width: 62,
    height: 36
  }, _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M73.4036 22.0961L38.1846 1.76215C37.5026 1.36815 36.4016 1.37115 35.7296 1.76215L13.3976 14.7462C12.7196 15.1402 12.7236 15.7742 13.4056 16.1682L48.6246 36.5021C49.3066 36.8961 50.4016 36.8961 51.0796 36.5021L73.4116 23.5181C74.0836 23.1281 74.0856 22.4901 73.4036 22.0961Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1921_13966)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M33.4837 25.3562L19.5117 17.2892L33.4837 9.22217L47.4557 17.2892L33.4837 25.3562Z",
    fill: "#FECA85"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.4837 40.126L19.5117 32.0601V17.2891L33.4837 25.356V40.126Z",
    fill: "#B78351"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.4554 32.0601L33.4834 40.126V25.356L47.4554 17.2891V32.0601Z",
    fill: "#E2B06D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.387 21.9483L25.415 13.8813L28.26 12.2393L42.232 20.3053L39.387 21.9483Z",
    fill: "#B6703B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.2317 26.4182L39.3867 28.0612V21.9482L42.2317 20.3052V26.4182Z",
    fill: "#91592F"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_1921_13966",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 12,
    y: 1,
    width: 62,
    height: 36
  }, _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M73.4036 22.0961L38.1846 1.76215C37.5026 1.36815 36.4016 1.37115 35.7296 1.76215L13.3976 14.7462C12.7196 15.1402 12.7236 15.7742 13.4056 16.1682L48.6246 36.5021C49.3066 36.8961 50.4016 36.8961 51.0796 36.5021L73.4116 23.5181C74.0836 23.1281 74.0856 22.4901 73.4036 22.0961Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_1921_13966)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M49.0231 31.8052L38.4961 25.7272L49.0231 19.6492L59.5511 25.7272L49.0231 31.8052Z",
    fill: "#FECA85"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.0231 42.9351L38.4961 36.8571V25.7271L49.0231 31.8051V42.9351Z",
    fill: "#B78351"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.5514 36.8571L49.0234 42.9351V31.8051L59.5514 25.7271V36.8571Z",
    fill: "#E2B06D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.4714 29.2381L42.9434 23.1601L45.0874 21.9221L55.6143 28.0001L53.4714 29.2381Z",
    fill: "#B6703B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.6147 32.606L53.4717 33.844V29.238L55.6147 28V32.606Z",
    fill: "#91592F"
  }))), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M23.8054 30.5078L6.08538 51.7871L34.7998 37.8295V36.8812L23.8054 30.5078Z",
    fill: "#FF8A8A"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M10.2574 53.1137L14.3223 50.7898L12.45 64.8741L8.42039 67.1993L10.2574 53.1137Z",
    fill: "#222222"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M10.2588 53.1137L6.2292 50.7898L4.39222 64.8741L8.42181 67.1993L10.2588 53.1137Z",
    fill: "#161616"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M9.48557 54.5542L22.0986 49.0274V40.4856L2.49982 50.5035L9.48557 54.5542Z",
    fill: "#393939"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M9.48557 49.9041L22.0986 40.4859L15.1129 36.4351L2.49982 45.8547L9.48557 49.9041Z",
    fill: "#838383"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M9.48535 49.9042V54.5545L2.4996 50.5038V45.8547L9.48535 49.9042Z",
    fill: "#272727"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M5.51891 56.1021L9.5498 58.4273L8.63066 65.4263L4.60107 63.1011L5.51891 56.1021Z",
    fill: "#F7900B"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M13.6201 56.0837L9.5513 58.4272L8.63216 65.4262L12.6631 63.1011L13.6201 56.0837Z",
    fill: "#FFB700"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1921_13966",
    x1: 48.3573,
    y1: 45.0235,
    x2: 51.2389,
    y2: 45.0235,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BC7400"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E69F00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1921_13966",
    x1: 48.18,
    y1: 36.2255,
    x2: 50.9369,
    y2: 36.2255,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BC7400"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E69F00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1921_13966",
    x1: 48.3573,
    y1: 27.6641,
    x2: 51.2389,
    y2: 27.6641,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BC7400"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E69F00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1921_13966",
    x1: 38.9799,
    y1: 19.1334,
    x2: 34.7051,
    y2: 19.1334,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BC7400"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E69F00"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgScanBox);
export default __webpack_public_path__ + "static/media/scanBox.577687da106e4a94604ea4f1dc3d3d8e.svg";
export { ForwardRef as ReactComponent };